import React from "react";

import s from "./MonthStatistics.module.scss";

const MonthStatistics = (props) => {
  return <div className={s.MonthStatistics}>MonthStatistics</div>;
};

export default MonthStatistics;
